import { render } from "./B2bTableCmrEmit.vue?vue&type=template&id=061ca075&scoped=true&lang=pug"
import script from "./B2bTableCmrEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableCmrEmit.vue?vue&type=script&lang=js"

import "./B2bTableCmrEmit.vue?vue&type=style&index=0&id=061ca075&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061ca075"]])

export default __exports__